import { render, staticRenderFns } from "./SupplierSizePacks.vue?vue&type=template&id=788ef2e6"
import script from "./SupplierSizePacks.ts?vue&type=script&lang=ts&external"
export * from "./SupplierSizePacks.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports